export default "__VITE_ASSET__e093134e__"